import './App.css';
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {createBrowserRouter, Outlet, RouterProvider} from "react-router-dom";
import Document from "./pages/Document";
import Teams from "./pages/Teams";
import Login from "./pages/Login";
import Register from "./pages/Register";
import HomePage from "./pages/HomePage";
import Home from "./pages/Home";
import {Programma} from "./pages/Programma";
import {DressCode} from "./pages/DressCode";
import {Contacts} from "./pages/Contacts";
import {News} from "./pages/News";
import {Recover} from "./pages/Recover";
import {AreaPersonale} from "./pages/AreaPersonale";
import ProtectedRoute from "./components/shared/ProtectedRoute";
import {Curiosita} from "./pages/Curiosita";
import {TempoLibero} from "./pages/TempoLibero";
import {InformazioniUtili} from "./pages/InformazioniUtili";
import {Agenda} from "./pages/Agenda";
import ScrollToTop from "./components/shared/ScrollToTop";

const Layout = () => {
    return (
        <>
            <ScrollToTop /> {/* ScrollToTop funziona qui dentro */}
            <Outlet />
        </>
    );
};


const router = createBrowserRouter([
    {
        element: <Layout />,
        children: [
            // PIATTAFORMA
            { path: '/set-login/:id', element: <Register/>},
            { path: '/login', element: <Login/>},
            { path: '/recover', element: <Recover/>},
            // PROTETTE
            { path: '/area-personale', element:<ProtectedRoute><AreaPersonale/></ProtectedRoute> },
            { path: '/agenda', element:<ProtectedRoute><Agenda/></ProtectedRoute> },
            { path: '/contatti', element:<ProtectedRoute><Contacts/></ProtectedRoute>},
            { path: '/curiosita', element:<ProtectedRoute> <Curiosita/></ProtectedRoute>},
            { path: '/tempo-libero', element:<ProtectedRoute> <TempoLibero/></ProtectedRoute>},
            { path: '/info', element:<ProtectedRoute> <InformazioniUtili/></ProtectedRoute>},
            { path: '/news', element:<ProtectedRoute><News/></ProtectedRoute> },
            { path: '/home', element:<ProtectedRoute><HomePage/></ProtectedRoute>},
            { path: '/', element:<ProtectedRoute><HomePage/></ProtectedRoute>}
        ]
    }


])

function App() {
  return (
      <LocalizationProvider dateAdapter={AdapterMoment}>
          <RouterProvider router={router} />
      </LocalizationProvider>
  );
}

export default App;
